import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import Atmosphere from './components/effects/Atmosphere';
import CursorGlow from './components/effects/CursorGlow';
import Marquee from './components/effects/Marquee';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Process from './components/Process';
import Beyond from './components/Beyond';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <ThemeProvider>
      <div className="relative min-h-screen bg-slate-50 text-slate-900 transition-colors duration-300 dark:bg-slate-950 dark:text-slate-50">
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[300]
                     focus:rounded-full focus:bg-emerald-600 focus:px-5 focus:py-3 focus:text-sm
                     focus:font-semibold focus:text-white"
        >
          Skip to content
        </a>

        <Atmosphere />
        <CursorGlow />
        <Header />

        <main id="main" className="relative z-[2]">
          <Hero />
          <Marquee />
          <About />
          <Services />
          <Projects />
          <Skills />
          <Experience />
          <Process />
          <Beyond />
          <Testimonials />
          <Contact />
        </main>

        <Footer />
      </div>
    </ThemeProvider>
  );
}
